module.exports = __webpack_public_path__ + "img/p2-46.d9b37866.png";